import { Grid, Typography } from '@mui/material';
import { WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface IFields {
  label: string;
  value?: string | number | string[];
}

interface IUserProfileInfoRender {
  fields: IFields[];
}

const UserProfileInfoRender = ({ fields }: IUserProfileInfoRender) => (
  <>
    {fields.map((f, idx) => (
      <Grid item xs={12} sm={4} md={2} key={idx}>
        <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
          {f.label}
        </WsTypography>
        <Typography
          variant={WsTypoVariants.BODY1}
          sx={{
            wordBreak: 'break-word',
            whiteSpace: 'normal',
          }}
        >
          {f.value ?? '-'}
        </Typography>
      </Grid>
    ))}
  </>
);

export default UserProfileInfoRender;
